import axios from "axios";

export default function PurchaseorderSummaryService(orderId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/purchase_order/" + orderId + "/summary",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
